import type { ComponentProps } from 'react'

import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import { useHighlightedText } from 'homepage/libs/hooks'

import * as styles from './title.styles'

export const HeroTitle = ({
  title,
  highlighted,
  variant = 'h1',
}: {
  title: string
  highlighted?: string
  variant?: Extract<
    ComponentProps<typeof Typography>['variant'],
    'h1' | 'h2' | 'h3'
  >
}) => {
  const { before, highlight, after } = useHighlightedText(title, highlighted)

  if (!highlight) {
    return (
      <Typography
        css={styles.heroTitle(variant)}
        fontWeight="heavy"
        variant={variant}
      >
        {title}
      </Typography>
    )
  }

  return (
    <Typography
      css={styles.heroTitle(variant)}
      fontWeight="heavy"
      variant={variant}
    >
      {before}
      <span css={styles.highlighted}>{highlight}</span>
      {after}
    </Typography>
  )
}
